import { useMovementPageData } from '#src/app/pages/movement/pageContext';

type Result = ModelHookResult<{
	description: string | null;
	objective: string;
	hasMovementPhoto: boolean;
	petitionCount: number;
	petitionCountLocalized: string;
	supporterCount: number;
	supporterCountLocalized: string;
}>;

export function usePageHeading(): Result {
	const {
		data: {
			movement: {
				description,
				objective,
				photo,
				petitionCount,
				petitionCountLocalized,
				uniqueSignatureCount: supporterCount,
				uniqueSignatureCountLocalized: supporterCountLocalized,
			},
		},
	} = useMovementPageData();

	const hasMovementPhoto = !!photo?.petitionMedium.url;

	return {
		data: {
			description,
			objective,
			hasMovementPhoto,
			petitionCount,
			petitionCountLocalized,
			supporterCount,
			supporterCountLocalized,
		},
	};
}
